import { ReplyOrder } from '@diritto/common/reply/constants';
import { RelayReplyApi } from 'api/ApiHelper';
import { useInfiniteQuery } from '@tanstack/react-query';
import { RepliesRelayResponseDto } from '@diritto/common/relay/dtos/reply-relay.dtos';
import { repliesQueryKey } from 'queries/reply/queryKey';

const DEFAULT_LIMIT = 20;

const getNextPageParam = (lastGroup: RepliesRelayResponseDto, allGroups: RepliesRelayResponseDto[]) => {
  if ((lastGroup.replies?.length ?? 0) < DEFAULT_LIMIT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.replies.length, 0);
};

export const useGetRelayContentRepliesInfiniteQuery = (contentId: number, orderBy: ReplyOrder) =>
  useInfiniteQuery({
    queryKey: repliesQueryKey.contentReplyList(contentId, orderBy),
    queryFn: ({ pageParam = 0 }) =>
      RelayReplyApi.getContentReplies(contentId, orderBy, { offset: pageParam, limit: DEFAULT_LIMIT }),
    initialPageParam: 0,
    getNextPageParam,
  });
